export default __webpack_public_path__ + "static/media/delivery-5.93a92a80.jpg";